import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { GenericBaseService } from './generic-base.service';
import {ApiVersion, UrlService} from './url.service';

@Injectable({
  providedIn: 'root'
})

export class BankTransactionDashboardService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('BankTransaction Logs', httpClient, toastrService, url, ApiVersion.v3);
  }
}
